<template>
    <div class="page-wrap">
        <div class="page-bar crm-board-bar">
            <div>
                <div class="page-bar-sub">Work</div>
                <div class="page-bar-main" style="display:flex;align-items:center;gap:8px">
                    <!-- Task managers keep their name -->
                    <span v-if="isTaskManager" style="font-size:24px;font-weight:bold">{{ formData.name }}</span>
                    <textarea v-else v-model="formData.name" @change="saveBoardData(true)" style="background:none;border:none;padding:0;color:white;font-size:24px;font-weight:bold;margin:0;height: auto;width: auto; field-sizing: content; min-inline-size: 20px; max-width: 100%;"></textarea>
                    <!-- Saves this board to the menu favorites as 'board:<slug>' (same key CompanyBoards.vue uses) -->
                    <button v-if="formData.slug" type="button" :class="isFavorite ? 'page-bar-fav on' : 'page-bar-fav'" :title="isFavorite ? 'Remove from favorites' : 'Add to favorites'" @click="toggleFavorite()">
                        <svg-icon :icon="isFavorite ? 'starfilled' : 'star'" />
                    </button>
                </div>
            </div>
            <div class="pb-actions">
                <button type="button" class="btn-light pb-btn hide-mobile-991" @click="$router.back()">Back</button>
                <!-- The Daily Digest for this person (ForgeDailyDigest, popup only): today's state, signatures needed, and the Forge's
                     deck actions (Tidy, Plan my week, Sort the Inbox) in it. Keelan, 20 Oct: one "The Forge" fewer on the board. -->
                <button type="button" class="ai-btn pb-btn pb-forge" @click="openDigest()"><svg style="fill: currentColor; stroke: none; width: 14px; height: 14px" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" fill-rule="evenodd"><path d="M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z"/></svg><span>The Daily Digest</span></button>
                <button type="button" class="btn-light pb-btn hide-mobile-991" @click="getActivity()">Activity</button>
                <div class="pb-more">
                    <button type="button" class="pb-kebab" aria-haspopup="menu" :aria-expanded="showOptionsMenu" aria-label="Board options" @click="showOptionsMenu = !showOptionsMenu">
                        <svg-icon icon="dots" />
                    </button>
                    <div v-if="showOptionsMenu" class="pb-menu" role="menu" @click="showOptionsMenu = false">
                        <button type="button" class="pb-mi mobile-991" role="menuitem" @click="getActivity()">Activity</button>
                        <button type="button" class="pb-mi" role="menuitem" @click="() => { editTags = !editTags; editColumns = false; }">{{ editTags ? 'Hide Tags' : 'Edit Tags' }}</button>
                        <button type="button" class="pb-mi" role="menuitem" @click="() => { editColumns = !editColumns; editTags = false; }">{{ editColumns ? 'Hide Columns' : 'Edit Columns' }}</button>
                        <button v-if="canEditUsers" type="button" class="pb-mi" role="menuitem" @click="editUsers()">Edit Users</button>
                        <button type="button" class="pb-mi" role="menuitem" @click="showSettings = true">Settings</button>
                        <!-- Admins and the deck's creator; task managers can't be deleted (companyboards.ts CanDelete) -->
                        <template v-if="canDelete">
                            <div class="pb-sep"></div>
                            <button type="button" class="pb-mi pb-mi-danger" role="menuitem" @click="showConfirmDeleteBoard = true">Delete Deck</button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <div class="bracing-rental">
                <div class="page-filters pf-bar">
                    <div class="pf-search">
                        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.35-4.35" /></svg>
                        <input type="text" v-model="searchQ" placeholder="Search by name" aria-label="Search by name" @input="search()" />
                    </div>
                    <div class="crm-board-filter-tags">
                        <div :class="filteredTagCount ? 'crm-board-filter-btn on' : 'crm-board-filter-btn'" @click="() => { showSelectTags = !showSelectTags }">
                            Filter Tags<span v-if="filteredTagCount"> ({{ filteredTagCount }})</span>
                        </div>
                        <div v-if="showSelectTags" class="board-item-tags">
                            <div style="display:flex;margin-bottom:10px;gap:10px">
                                <div @click="() => { showSelectTags = false; search(); }" class="btn" style="margin:0">Save</div>
                                <div @click="clearFilterTags()" class="btn-light" style="margin:0">Clear</div>
                            </div>
                            <div class="board-item-tags-tags">
                                <div v-for="(tag, i) in formData.tags" :key="i" class="checkbox-input customer-request-tag" :style="'font-size:14px;background:'+tag.color">
                                    <input style="margin-left: 10px" type="checkbox" v-model="tag.filterSelected" />
                                    <span style="margin-left:0">{{ tag.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span class="pf-spacer"></span>
                    <div @click="() => { showScorecard = true }" class="btn">Scorecard</div>
                    <div @click="() => { showRocks = true }" class="btn">Rocks</div>
                    <div @click="() => { showGoals = true }" class="btn">Personal Goals</div>
                </div>
                <div v-if="editTags" class="crm-board-edit-panel">
                    <div class="crm-board-edit-title">Tags<span>Drag to reorder</span></div>
                    <form class="crm-board-edit-add" @submit.prevent="addTag()">
                        <input type="text" placeholder="Tag name" v-model="addTagName" />
                        <div class="crm-board-color-select">
                            <select v-model="addTagColor">
                                <option v-for="(color, i) in $store.state.colorPalette" :key="i" :value="color.hex">{{ color.label }}</option>
                            </select>
                            <input type="color" v-model="addTagColor" title="Custom color" />
                        </div>
                        <button class="add-btn">Add</button>
                    </form>
                    <draggable v-model="formData.tags" class="crm-board-edit-chips crm-board-edit-chips-tags">
                        <div :style="'background:'+tag.color" v-for="(tag, i) in formData.tags" :key="i">
                            <span>{{ tag.name }}</span>
                            <span class="crm-board-edit-chip-x" title="Remove" @click="removeTag(i)"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"/></svg></span>
                        </div>
                    </draggable>
                    <div class="crm-board-edit-actions">
                        <button type="button" class="btn" @click="saveBoardData(false)">Save</button>
                        <button type="button" class="btn-light" @click="cancelBoardEdit()">Cancel</button>
                    </div>
                </div>
                <edit-columns-panel v-if="editColumns" :columns="formData.columns" :hint="isTaskManager ? 'items sent from meetings land in the first column' : ''" @save="saveBoardData(false)" @cancel="cancelBoardEdit()" @remove="removeCol" @add="(col) => formData.columns.push(col)" />
                <!-- Phones show one column at a time; these arrows page between them -->
                <div class="crm-board-mobile-arrow crm-board-mobile-arrow-left mobile-767" :class="mobileColIndex <= 0 ? 'disabled' : ''" @click="mobilePrevCol()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M15.41 7.41l-1.41-1.41-6 6 6 6 1.41-1.41-4.58-4.59z"/></svg>
                </div>
                <div class="crm-board-mobile-arrow crm-board-mobile-arrow-right mobile-767" :class="mobileColIndex >= mobileColumnKeys.length - 1 ? 'disabled' : ''" @click="mobileNextCol()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M8.59 16.59l1.41 1.41 6-6-6-6-1.41 1.41 4.58 4.59z"/></svg>
                </div>
                <div class="kanban board-mobile-cols">
                    <!-- The inbox is the board's first column, so on phones the arrows page to it like any other -->
                    <inbox-panel v-if="inboxShown" ref="inboxPanel" :class="activeMobileColumn === INBOX_COL ? 'crm-board-col-active' : ''" :slug="formData.slug" :show-rocks="isMyTaskManager" @moved="loadItems(false)" @open="openInboxCard" @open-rock="openInboxRock" />
                    <template v-for="(col, i) in formData.columns">
                        <!-- kanban-col-tinted: the column's color as its background (style.scss) -->
                        <div v-if="col.show" :key="i" class="kanban-col kanban-col-tinted" :class="col.name === activeMobileColumn ? 'crm-board-col-active' : ''" :style="{ '--col-color': col.color }">
                            <div class="kanban-colh">
                                <span class="kanban-coldot" :style="{ background: col.color }"></span>
                                <input v-if="col.showEdit" class="crm-board-col-rename" type="text" v-model="col.editInput" @change="submitEditColName(col)" @blur="() => { col.showEdit = false }" @keyup.esc="() => { col.showEdit = false }" :ref="'colRename' + i" />
                                <span v-else class="crm-board-col-name" title="Click to rename" @click="editColName(col, i)">{{ col.name }}</span>
                                <span class="kanban-coladd" title="Add card" @click="addEditItem(col.name, null)"><svg-icon icon="plus" /></span>
                                <span class="kanban-colcnt">{{ (itemsByColumn[col.name] || []).length }}</span>
                                <svg-icon icon="arrowsin" class="kanban-colcollapse" @click="() => { col.show = false }" />
                            </div>
                            <div class="kanban-colb">
                                <draggable class="crm-board-cards" :list="itemsByColumn[col.name]" group="column" @change="dragEnd($event, col.name)" :animation="150" ghost-class="kanban-ghost" :empty-insert-threshold="40" :force-auto-scroll-fallback="true" :scroll-sensitivity="120" :scroll-speed="20" :delay="200" :delay-on-touch-only="true" :touch-start-threshold="5">
                                    <div v-for="item in itemsByColumn[col.name]" :key="(item.InboxItem ? 'inbox' : item.RockRow ? 'rock' : '') + item.ID" v-show="!item.hide" class="crm-board-card" :class="item.Overdue ? 'crm-board-item-overdue' : ''" @click="addEditItem(null, item, $event)">
                                        <div v-if="item.CardColor" class="item-card-color-cover" :style="'background:'+item.CardColor"></div>
                                        <div class="crm-board-item-body">
                                            <h3><input type="checkbox" v-model="item.Checked" @change="item.MeetingItem ? meetingItemCompleteChange(item) : itemChange(item)" />{{ item.Name }}</h3>
                                            <div class="customer-request-tags">
                                                <div v-if="item.PriorityTag" :style="'background:'+item.PriorityTag.color">{{ item.PriorityTag.name }}</div>
                                                <div v-for="(tag, k) in item.TagsJSON" :key="k" :style="'background:'+tagColor(item, tag)">{{ tag }}</div>
                                            </div>
                                            <div class="customer-request-tags crm-extra-tags">
                                                <div v-if="item.DateDisplay" :class="item.Overdue ? 'crm-extra-tag-overdue' : 'crm-extra-tag-date'"><svg-icon icon="clock" />{{ item.DateDisplay }}</div>
                                                <div v-if="item.CommentCount != '0'"><svg-icon icon="comment" />{{ item.CommentCount }}</div>
                                                <div v-if="item.FileCount != '0'"><svg-icon icon="paperclip" />{{ item.FileCount }}</div>
                                                <div v-if="item.TotalChecklistItems"><svg-icon icon="checkbox" />{{ item.CheckedChecklistItems }} / {{ item.TotalChecklistItems }}</div>
                                                <div v-if="item.MeetingName" :title="'From meeting: ' + item.MeetingName"><svg-icon icon="twousers" />{{ item.MeetingName }}</div>
                                                <!-- A rock card: the rock's status and milestones (its checkbox is the card's own) -->
                                                <template v-if="item.Rock">
                                                    <div class="crm-rock-st" :class="rockStatus(item.Rock.Status).cls" :title="'Rock · ' + quarterLabel(item.Rock.Quarter)"><svg-icon icon="star" />{{ rockStatus(item.Rock.Status).label }}</div>
                                                    <div v-if="item.Rock.MilestoneCount" title="Milestones done"><svg-icon icon="checkbox" />{{ item.Rock.MilestonesDone }} / {{ item.Rock.MilestoneCount }}</div>
                                                </template>
                                                <div v-if="item.HomeBoard" :title="'Mirrored from ' + item.HomeBoard.Name"><svg-icon icon="copy" />{{ item.HomeBoard.Name }}</div>
                                                <div v-else-if="item.MirrorBoards.length" :title="'Also on ' + boardNames(item.MirrorBoards)"><svg-icon icon="copy" />{{ item.MirrorBoards.length }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </draggable>
                                <span class="kanban-addbtn" @click="addEditItem(col.name, null)">+ Add card</span>
                            </div>
                        </div>
                        <div v-else class="kanban-col kanban-col-collapsed kanban-col-tinted" @click="() => { col.show = true }" :key="'a'+i" :style="{ '--col-color': col.color }">
                            <svg-icon icon="arrowsout" class="kanban-colcollapse" />
                            <span>{{ col.name }}</span>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div v-if="showActivity" class="board-activity">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="() => { showActivity = false }">&times;</button>
            </div>
            <div class="board-activity-tabs">
                <div @click="() => { showActivityGroup = 'Details' }" :class="showActivityGroup == 'Details' ? 'on' : ''">Details</div>
                <div @click="() => { showActivityGroup = 'Cards' }" :class="showActivityGroup == 'Cards' ? 'on' : ''">Cards</div>
            </div>
            <div v-if="showActivityGroup == 'Details'" class="board-activity-list">
                <div v-for="(a, i) in activity" :key="i">
                    <div class="board-activity-date">{{ a.DateDisplay }}</div>
                    <div><b>{{ a.Username }}</b> {{ a.Text }} <a @click.prevent="addEditItemFromID(a.CardID)">{{ a.CardName }}</a></div>
                </div>
            </div>
            <div v-else class="board-activity-list">
                <div v-for="(a, i) in activityCards" :key="i">
                    <div class="board-activity-date">{{ a.DateDisplay }}</div>
                    <div><a @click.prevent="addEditItemFromID(a.CardID)">{{ a.CardName }}</a></div>
                </div>
            </div>
        </div>

        <component :is="'style'">
            @media(max-width: 767px) {
                #pb-widget-btn, .af-launch { display: none !important; }
            }
        </component>

        <forge-daily-digest v-if="formData.slug" ref="digest" button-mode board-actions @forge="openForge($event)" />
        <forge-team v-if="showForge" modal :only="[ 'tidyboard', 'planweek', 'sortinbox' ]" :start-kind="forgeKind" :board="forgeBoard" @applied="forgeApplied()" @close="showForge = false" />
        <add-new-company-board-item v-if="showAddNewItem" :item="addEditData" :tags="formData.tags" @close="closeAddNew" />
        <!-- A mirrored card's tags are picked from its home board's; a card in the inbox has the inbox's tags and column,
             and its Move offers this board first -->
        <add-edit-company-board-item v-if="showAddEditItem" :item="addEditData" :tags="addEditData.HomeTags || (inboxCard ? inboxCard.tags : formData.tags)" :columns="inboxCard ? inboxCard.columns : formData.columns" :default-move-slug="inboxCard ? formData.slug : null" @close="closeAddEdit()" />
        <!-- A card that's a meeting item opens the meeting item itself -->
        <add-edit-meeting-item v-if="meetingItemCard" :item="meetingItemCard.MeetingItem" :employees="meetingItemAssignees" :from-meeting="{ Name: meetingItemCard.MeetingName, CanOpen: meetingItemCard.CanOpenMeeting }" @close="closeMeetingItem()" />
        <move-column-prompt v-if="completedMove" message="Marked completed." noun="card" board="deck" :columns="columnNames" :current="completedMove.current" :default-column="completedMove.column" @move="moveItemToColumn(completedMove.itemID, $event); completedMove = null" @cancel="completedMove = null" />
        <deck-settings-modal v-if="showSettings" :slug="formData.slug" :columns="columnNames" :complete-action="completeAction" :complete-column="completeColumn" @saved="settingsSaved" @close="showSettings = false" />
        <confirm-delete v-if="showConfirmDeleteBoard" @confirm="deleteBoard()" @cancel="showConfirmDeleteBoard = false" msg="Delete this deck and all of its cards? Its cards also come off any other decks they are mirrored onto." />
        <select-employees v-if="showEditUsers" title="Share with" source="/api/employees/picker" :selectedIds="editUsersCurrent" :lockedIds="editUsersLocked" :lockedNote="isTaskManager ? 'Owner' : 'Creator'" @save="saveUsers" @close="() => { showEditUsers = false; }" />
        <pdf-pop-up v-if="showScorecard" :url="'/scoreboard?hideNav=t&hideChat=t'" @close="() => { showScorecard = false }" />
        <pdf-pop-up v-if="showRocks" :url="'/scoreboard?view=rocks&hideNav=t&hideChat=t'" @close="() => { showRocks = false }" />
        <pdf-pop-up v-if="showGoals" :url="'/scoreboard?view=goals&hideNav=t&hideChat=t'" @close="() => { showGoals = false }" />
        <!-- A rock card opens the rock's own form, as on the Rocks page -->
        <rock-modal v-if="rockCard" :rock="rockCard.rock" :quarter="rockCard.rock.Quarter" :employees="rockCard.employees" :teams="rockCard.teams" :myEmployeeID="rockCard.myEmployeeID" :on-board="!!rockCard.card" :add-columns="rockCard.card ? null : columnNames" :add-column="addRockColumn" @close="closeRockCard()" @saved="rockCardSaved" @remove-from-board="removeRockCard()" @add-to-board="addInboxRockToBoard" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import { VueDraggableNext } from 'vue-draggable-next';
import AddEditCompanyBoardItem from '@/components/AddEditCompanyBoardItem.vue';
import AddNewCompanyBoardItem from '@/components/AddNewCompanyBoardItem.vue';
import AddEditMeetingItem from '@/components/AddEditMeetingItem.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import SelectEmployees from '@/components/SelectEmployees.vue';
import InboxPanel from '@/components/InboxPanel.vue';
import PDFPopUp from '@/components/PDFPopUp.vue';
import RockModal from '@/components/RockModal.vue';
import ForgeTeam from '@/components/ForgeTeam.vue';
import ForgeDailyDigest from '@/components/ForgeDailyDigest.vue';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import EditColumnsPanel from '@/components/EditColumnsPanel.vue';
import MoveColumnPrompt from '@/components/MoveColumnPrompt.vue';
import DeckSettingsModal from '@/components/DeckSettingsModal.vue';
import { rockStatus, quarterLabel } from '@/rocks';
import { prepareCard, cardDateInfo } from '@/boardCards';

// The inbox's key among the phone column pages; column names are trimmed, so none can match it
const INBOX_COL = '\u0000inbox';

export default defineComponent({
    name: 'CompanyBoard',
    components: {
        draggable: VueDraggableNext,
        InboxPanel,
        ForgeTeam,
        ForgeDailyDigest,
        AddEditCompanyBoardItem,
        AddNewCompanyBoardItem,
        AddEditMeetingItem,
        SvgIcon,
        SelectEmployees,
        PdfPopUp: PDFPopUp,
        RockModal,
        ConfirmDelete,
        EditColumnsPanel,
        MoveColumnPrompt,
        DeckSettingsModal
    },
    data() {
        return {
            INBOX_COL,
            formData: {
                name: '',
                slug: '',
                tags: [] as any,
                columns: [] as any,
            },
            tagColors: {} as any,
            editTags: false,
            editColumns: false,
            addTagName: '',
            addTagColor: '#000000',
            itemsByColumn: {} as any,
            showAddEditItem: false,
            showAddNewItem: false,
            addEditData: {} as any,
            inboxCard: null as any, // { tags, columns } while the card open in the form is one from the inbox
            meetingItemCard: null as any,
            employees: null as any,
            editUsersCurrent: [] as any,
            editUsersLocked: [] as any,
            showEditUsers: false,
            canEditUsers: false,
            isTaskManager: false,
            isMyTaskManager: false,
            showForge: false,
            forgeKind: 'tidyboard', // which Forge deck action the digest popup asked for
            mobileActiveCol: '',
            showOptionsMenu: false,
            canDelete: false,
            showConfirmDeleteBoard: false,
            searchQ: '',
            showSelectTags: false,
            columnOrderTimeouts: {} as any,
            showActivity: false,
            showActivityGroup: 'Details',
            activity: [] as any,
            activityCards: [] as any,
            showScorecard: false,
            showRocks: false,
            showGoals: false,
            // The rock open in the rock's form: { card, rock, employees, teams, myEmployeeID }. card is null for one opened
            // from the inbox's Rocks list, not on the board yet (the form's "Add to Board" puts it on)
            rockCard: null as any,
            completedMove: null as any, // { itemID, current, column } while the move prompt after checking a card off is open
            // The deck's setting for checking a card off (Settings): 'prompt' (the default), 'none', or 'move' to completeColumn
            completeAction: 'prompt',
            completeColumn: '',
            showSettings: false
        }
    },
    computed: {
        isFavorite(): boolean {
            return this.$store.state.navFavorites.includes('board:' + this.formData.slug);
        },
        columnNames(): string[] {
            return (this.formData.columns || []).map((c: any) => c.name);
        },
        // What the Forge's board actions work from (ForgeTeam's board prop)
        forgeBoard(): any {
            return { slug: this.formData.slug, name: this.formData.name, columns: this.columnNames, cards: Object.values(this.itemsByColumn || {}).flat() };
        },
        visibleColumnsList(): any {
            return (this.formData.columns || []).filter((c: any) => c.show);
        },
        // Falls back to the first visible column when the chosen one is hidden or removed
        inboxShown(): boolean {
            return !!this.formData.slug;
        },
        // What the phone arrows page through: the inbox (INBOX_COL), then the visible columns
        mobileColumnKeys(): string[] {
            return (this.inboxShown ? [ INBOX_COL ] : []).concat(this.visibleColumnsList.map((c: any) => c.name));
        },
        // Falls back to the first visible column (else the inbox) when the chosen one is hidden or removed
        activeMobileColumn(): string {
            if(this.mobileColumnKeys.includes(this.mobileActiveCol)) {
                return this.mobileActiveCol;
            }
            return this.visibleColumnsList.length ? this.visibleColumnsList[0].name : (this.mobileColumnKeys[0] || '');
        },
        mobileColIndex(): number {
            return this.mobileColumnKeys.indexOf(this.activeMobileColumn);
        },
        filteredTagCount(): number {
            return this.formData.tags.filter((t: any) => t.filterSelected).length;
        },
        // Who the open meeting item can be assigned to, as on its meeting board
        // Where the rock form's "Add to Board" starts: on a phone, the column showing; otherwise the first
        addRockColumn(): string {
            return this.columnNames.includes(this.activeMobileColumn) ? this.activeMobileColumn : (this.columnNames[0] || '');
        },
        meetingItemAssignees(): any[] {
            const ids = this.meetingItemCard?.MeetingAssigneeIDs;
            const employees = this.employees || [];
            return ids ? employees.filter((e: any) => ids.includes(e.ID)) : employees;
        }
    },
    async created() {
        if(!this.$route.params.slug) {
            return;
        }

        await this.loadItems(true);

        this.$store.state.routeLoaded = true;

        // ?openCard=<id> opens that card
        if(this.$route.query.openCard) {
            this.addEditItemFromID(this.$route.query.openCard);
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
        for(const col in this.columnOrderTimeouts) {
            clearTimeout(this.columnOrderTimeouts[col]);
        }
    },
    methods: {
        rockStatus,
        quarterLabel,
        handleOutsideClick(e: MouseEvent) {
            const target = e.target as HTMLElement;
            if(this.showOptionsMenu && !target.closest('.pb-more')) {
                this.showOptionsMenu = false;
            }
            if(this.showSelectTags && !target.closest('.crm-board-filter-tags')) {
                this.showSelectTags = false;
            }
        },
        toggleFavorite() {
            this.$store.dispatch('toggleFavorite', 'board:' + this.formData.slug);
        },
        // Loads who the board is shared with, and who can't be taken off (a deck's creator, a task manager's owner)
        async editUsers() {
            await axios.get(`${this.$store.state.apiUrl}/api/companyboards/users/${this.formData.slug}`)
                .then(resp => {
                    this.editUsersCurrent = resp.data.EmployeeIDs;
                    this.editUsersLocked = resp.data.LockedIDs;
                    this.showEditUsers = true;
                })
                .catch(e => {
                    alert('There was an error');
                    console.log(e);
                })
        },
        // Back to the Decks page once it's gone (the API removes its cards and their mirrors)
        async deleteBoard() {
            this.showConfirmDeleteBoard = false;
            try {
                await axios.delete(`${this.$store.state.apiUrl}/api/companyboards/${this.formData.slug}`);
            } catch(e: any) {
                console.log(e);
                alert(e?.response?.data || 'There was an error');
                return;
            }
            // Favorited decks in the menu follow the list
            this.$store.state.companyBoards = (this.$store.state.companyBoards || []).filter((b: any) => b.Slug != this.formData.slug);
            this.$router.push('/decks');
        },
        async saveUsers(employeeIDs: number[]) {
            const data = {
                slug: this.formData.slug,
                employeeIDs
            }
            await axios.post(`${this.$store.state.apiUrl}/api/companyboards/users`, data)
                .then(() => {
                    this.showEditUsers = false;
                })
                .catch(e => {
                    alert('There was an error');
                    console.log(e);
                })
        },
        async loadItems(init: boolean) {
            if(init) {
                this.tagColors = {};
                await axios.get(`${this.$store.state.apiUrl}/api/companyboards/${this.$route.params.slug}`)
                    .then(resp => {
                        // Tag filters survive a reload of the board data
                        const filtered = this.formData.tags.filter((t: any) => t.filterSelected).map((t: any) => t.name);
                        this.formData.name = resp.data.Name;
                        this.formData.slug = resp.data.Slug;
                        this.canEditUsers = !!resp.data.CanEditUsers; // anyone on a deck; on a task manager, as canManage
                        this.canDelete = !!resp.data.CanDelete;
                        this.isTaskManager = resp.data.IsTaskManager;
                        this.isMyTaskManager = !!resp.data.IsMyTaskManager;
                        this.completeAction = resp.data.CompleteAction || 'prompt';
                        this.completeColumn = resp.data.CompleteColumn || '';
                        this.formData.columns = JSON.parse(resp.data.Columns);
                        for(const col of this.formData.columns) {
                            col.show = true;
                        }
                        this.formData.tags = JSON.parse(resp.data.Tags);
                        for(const tag of this.formData.tags) {
                            tag.filterSelected = filtered.includes(tag.name);
                            this.tagColors[tag.name] = tag.color;
                        }
                    })
                    .catch(e => {
                        console.log(e);
                    })
            }

            const itemsByColumn = {} as any;
            for(const column of this.formData.columns) {
                column.showEdit = false;
                itemsByColumn[column.name] = [];
            }

            const lastColumn = this.formData.columns.length ? this.formData.columns[this.formData.columns.length - 1].name : null;

            await axios.get(`${this.$store.state.apiUrl}/api/companyboarditems/${this.$route.params.slug}`)
                .then(resp => {
                    for(const item of resp.data) {
                        prepareCard(item, lastColumn, this.$store.state.monthShortStrings);
                        if(itemsByColumn[item.Column]) {
                            itemsByColumn[item.Column].push(item);
                        }
                    }

                    for(const col in itemsByColumn) {
                        this.overdueFirst(itemsByColumn[col]);
                    }
                })
                .catch(e => {
                    console.log(e);
                })

            this.itemsByColumn = itemsByColumn;
            this.search();
        },
        // Overdue cards first, otherwise in their saved order. In place, so it also re-sorts a column the user just dropped into
        overdueFirst(list: any[]) {
            const sorted = list.filter((it: any) => it.Overdue).concat(list.filter((it: any) => !it.Overdue));
            list.splice(0, list.length, ...sorted);
        },
        dateInfo(date: string) {
            return cardDateInfo(date, this.$store.state.monthShortStrings);
        },
        boardNames(boards: any[]): string {
            return boards.map((b: any) => b.Name).join(', ');
        },
        // A mirrored card's tags take their colors from its home board, falling back to this board's
        tagColor(item: any, tag: string): string {
            const homeTag = (item.HomeTags || []).find((t: any) => t.name == tag);
            return homeTag ? homeTag.color : this.tagColors[tag];
        },
        // Hides cards that don't match the name search or any of the selected tags
        search() {
            const q = this.searchQ.trim().toLowerCase();
            const tagNames = this.formData.tags.filter((t: any) => t.filterSelected).map((t: any) => t.name);
            for(const col in this.itemsByColumn) {
                for(const item of this.itemsByColumn[col]) {
                    let hide = false;
                    if(q && !(item.Name || '').toLowerCase().includes(q)) {
                        hide = true;
                    }
                    // A meeting item's priority counts as its tag
                    const itemTags = item.PriorityTag ? [ item.PriorityTag.name ] : item.TagsJSON;
                    if(!hide && tagNames.length && !itemTags.some((t: string) => tagNames.includes(t))) {
                        hide = true;
                    }
                    item.hide = hide;
                }
            }
        },
        clearFilterTags() {
            for(const tag of this.formData.tags) {
                tag.filterSelected = false;
            }
            this.search();
            this.showSelectTags = false;
        },
        addTag() {
            if(!this.addTagName) {
                return;
            }
            this.formData.tags.push({
                name: this.addTagName,
                color: this.addTagColor
            })
            this.addTagName = '';
        },
        removeTag(i:number) {
            this.formData.tags.splice(i, 1);
        },
        removeCol(i:number) {
            // Items sent to a task manager land in its first column, so it always keeps one
            if(this.isTaskManager && this.formData.columns.length <= 1) {
                alert('A task manager needs at least one column.');
                return;
            }
            if(this.itemsByColumn[this.formData.columns[i].name] && this.itemsByColumn[this.formData.columns[i].name].length) {
                alert('This column has items and cannot be removed. Move the items to a new column before removing.')
                return;
            }
            this.formData.columns.splice(i, 1);
        },
        // Drops unsaved tag/column edits
        cancelBoardEdit() {
            this.editTags = false;
            this.editColumns = false;
            this.loadItems(true);
        },
        async saveBoardData(nameChange: boolean) {
            await axios.post(`${this.$store.state.apiUrl}/api/companyboards/update`, this.formData)
                .catch(e => {
                    console.log(e);
                    alert('There was an error.')
                })

            if(!nameChange) {
                this.editTags = false;
                this.editColumns = false;
                this.loadItems(true);
            }
        },
        editColName(col: any, i: number) {
            col.editInput = col.name;
            col.showEdit = true;
            this.$nextTick(() => {
                const ref = this.$refs['colRename' + i] as any;
                const input = Array.isArray(ref) ? ref[0] : ref;
                input?.focus();
                input?.select();
            });
        },
        async submitEditColName(col: any) {
            const newName = (col.editInput || '').trim();
            if(!newName || newName == col.name) {
                col.showEdit = false;
                return;
            }
            if(this.formData.columns.find((c: any) => c !== col && c.name.toLowerCase() == newName.toLowerCase())) {
                alert('There is already a column with this name');
                return;
            }
            const data = {
                slug: this.formData.slug,
                oldColName: col.name,
                newColName: newName,
                newCols: this.formData.columns.map((c: any) => ({ name: c === col ? newName : c.name, color: c.color }))
            }
            await axios.post(`${this.$store.state.apiUrl}/api/companyboards/renamecolumn`, data)
                .catch(e => {
                    console.log(e);
                    alert(e?.response?.data || 'There was an error');
                })
            await this.loadItems(true);
        },
        addEditItem(col: string|null, editItem: any, event?: any) {
            // The card's own checkbox shouldn't open it
            if(event?.target?.nodeName == 'INPUT') {
                return;
            }
            if(editItem?.MeetingItem) {
                this.openMeetingItem(editItem);
            } else if(editItem?.Rock) {
                this.openRockCard(editItem);
            } else if(editItem) {
                this.addEditData = editItem;
                this.inboxCard = null;
                this.showAddEditItem = true;
            } else {
                this.addEditData = {
                    ID: null as any,
                    Name: '',
                    Description: '',
                    Column: col,
                    TagsJSON: [],
                    Date: null,
                    Slug: this.$route.params.slug
                }
                this.showAddNewItem = true;
            }
        },
        // id: the card's own ID, or for a mirror on this board, its home card's (activity and links
        // from other boards go by the home card)
        addEditItemFromID(id: any) {
            for(const col in this.itemsByColumn) {
                const item = this.itemsByColumn[col].find((it: any) => it.ID == id || (it.MirrorOfItemID && it.MirrorOfItemID == id));
                if(item) {
                    this.addEditItem(null, item);
                    return;
                }
            }
            alert('That card could not be found.');
        },
        // The Daily Digest button: the digest popup, or straight to the Forge when this login has no digest
        openDigest() {
            const d = this.$refs.digest as any;
            if(d && !d.hidden) d.openPop();
            else this.openForge('tidyboard');
        },
        openForge(kind: string) {
            this.forgeKind = kind;
            this.showForge = true;
        },
        // After the Forge changes cards or moves Inbox notes onto the board
        forgeApplied() {
            this.loadItems(false);
            (this.$refs.inboxPanel as any)?.load?.();
        },
        // A card from the inbox (InboxPanel.vue) opens in the card form like one on this board
        openInboxCard(item: any) {
            const panel = this.$refs.inboxPanel as any;
            this.addEditData = item;
            this.inboxCard = { tags: panel?.inboxTags || [], columns: panel?.INBOX_COLUMNS || [] };
            this.showAddEditItem = true;
        },
        // An inbox card dropped on a column moves there whole (element.Slug is the inbox's), where it was dropped
        async addFromInbox(element: any, column: string) {
            try {
                await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/move`, { Slug: element.Slug, ID: element.ID, TargetSlug: this.formData.slug, Column: column });
                element.InboxItem = false;
                await this.saveItemColumnOrder(column);
                // Its tags this board didn't have were added to it
                await this.loadBoardTags();
            } catch(e: any) {
                console.log(e);
                alert(e?.response?.data || 'There was an error adding that to the board.');
            }
            (this.$refs.inboxPanel as any)?.load();
            await this.loadItems(false);
        },
        // The board's tags again, keeping the tag filter
        async loadBoardTags() {
            const board = (await axios.get(`${this.$store.state.apiUrl}/api/companyboards/${this.formData.slug}`)).data;
            const filtered = this.formData.tags.filter((t: any) => t.filterSelected).map((t: any) => t.name);
            this.formData.tags = JSON.parse(board.Tags || '[]');
            for(const tag of this.formData.tags) {
                tag.filterSelected = filtered.includes(tag.name);
                this.tagColors[tag.name] = tag.color;
            }
        },
        // A rock from the inbox's Rocks list dropped on a column becomes its card there (InboxPanel.vue)
        async addFromRock(element: any, column: string) {
            try {
                const resp = await axios.post(`${this.$store.state.apiUrl}/api/rocks/rock/toboard`, { ID: element.ID, Slug: this.formData.slug, Column: column });
                element.ID = resp.data.ID;
                element.RockRow = false;
                await this.saveItemColumnOrder(column);
            } catch(e: any) {
                console.log(e);
                alert(e?.response?.data || 'There was an error adding that to the board.');
            }
            (this.$refs.inboxPanel as any)?.loadRocks();
            await this.loadItems(false);
        },
        async dragEnd(event: any, column: string) {
            if(event.added?.element?.InboxItem) {
                await this.addFromInbox(event.added.element, column);
                return;
            }
            if(event.added?.element?.RockRow) {
                await this.addFromRock(event.added.element, column);
                return;
            }
            if(event.added) {
                const item = event.added.element;
                item.Column = column;
                // Into or out of the last (done) column changes whether it's overdue, as worked out in loadItems
                if(item.Date) {
                    item.Overdue = this.dateInfo(item.Date).Overdue && !item.Checked && column != this.columnNames[this.columnNames.length - 1];
                }
                this.overdueFirst(this.itemsByColumn[column]);
                await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/changecolumn`, item)
                    .catch(e => {
                        console.log(e);
                        alert('There was an error.')
                    })
            }
            // Keeps where the card was dropped, except overdue cards stay on top as they load, so the column already
            // shows the order a refresh will; saved after a pause so a few quick drags make one request
            if(event.added || event.moved) {
                this.overdueFirst(this.itemsByColumn[column]);
                if(this.columnOrderTimeouts[column]) {
                    clearTimeout(this.columnOrderTimeouts[column]);
                }
                this.columnOrderTimeouts[column] = setTimeout(() => {
                    delete this.columnOrderTimeouts[column];
                    this.saveItemColumnOrder(column);
                }, 1500);
            }
        },
        async saveItemColumnOrder(column: string) {
            const items = (this.itemsByColumn[column] || []).map((item: any, i: number) => ({ id: item.ID, order: i }));
            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/columnorder`, { slug: this.formData.slug, items })
                .catch(e => {
                    console.log(e);
                })
        },
        mobilePrevCol() {
            const idx = this.mobileColIndex;
            if(idx > 0) {
                this.mobileActiveCol = this.mobileColumnKeys[idx - 1];
            }
        },
        mobileNextCol() {
            const idx = this.mobileColIndex;
            if(idx > -1 && idx < this.mobileColumnKeys.length - 1) {
                this.mobileActiveCol = this.mobileColumnKeys[idx + 1];
            }
        },
        async closeAddNew(id: any) {
            this.showAddNewItem = false;
            if(!id) {
                return;
            }
            // Opens the new card so checklists, comments and files can be added right away
            await this.loadItems(false);
            this.addEditItemFromID(id);
        },
        // Its Move may have taken it between this board and the inbox
        closeAddEdit() {
            this.showAddEditItem = false;
            this.inboxCard = null;
            this.loadItems(false);
            (this.$refs.inboxPanel as any)?.load();
        },
        // A rock from the inbox's Rocks list: its form, as for a rock card, with "Add to Board"
        openInboxRock(r: any) {
            this.openRockCard(null, r);
        },
        // Opens a rock card's rock (or, with no card, inboxRock) in its form, with what the form needs from the Rocks API
        // for its quarter
        async openRockCard(card: any, inboxRock: any = null) {
            const which = card ? card.Rock : inboxRock;
            try {
                const data = (await axios.get(`${this.$store.state.apiUrl}/api/rocks`, { params: { quarter: which.Quarter } })).data;
                const rock = data.Rocks.find((r: any) => r.ID == which.ID);
                if(!rock) {
                    alert('You don\'t have access to this rock.');
                    return;
                }
                this.rockCard = {
                    card,
                    rock,
                    employees: data.Employees.map((e: any) => ({ ...e, ID: Number(e.ID) })),
                    teams: data.Teams,
                    myEmployeeID: data.MyEmployeeID
                };
            } catch(e) {
                console.log(e);
                alert('There was an error');
            }
        },
        closeRockCard() {
            this.rockCard = null;
            this.loadItems(false);
        },
        // keepOpen: a change saved straight away (status, a milestone checked off) with the form still open
        rockCardSaved(keepOpen = false) {
            if(!keepOpen) {
                this.closeRockCard();
                (this.$refs.inboxPanel as any)?.loadRocks();
            } else {
                this.loadItems(false);
            }
        },
        // The rock form's "Add to Board": the top of that column, as dragging it there does. The form stays open (keeping any
        // edits in it), now as the rock's card.
        async addInboxRockToBoard(column: string) {
            try {
                const resp = await axios.post(`${this.$store.state.apiUrl}/api/rocks/rock/toboard`, { ID: this.rockCard.rock.ID, Slug: this.formData.slug, Column: column });
                this.rockCard.card = { ID: resp.data.ID, Rock: this.rockCard.rock };
            } catch(e: any) {
                console.log(e);
                alert(e?.response?.data || 'There was an error');
                return;
            }
            this.loadItems(false);
            (this.$refs.inboxPanel as any)?.loadRocks();
        },
        // Takes the card off this board; the rock stays, and goes back to the inbox's Rocks list
        async removeRockCard() {
            try {
                await axios.delete(`${this.$store.state.apiUrl}/api/companyboarditems/${this.rockCard.card.ID}`);
            } catch(e) {
                console.log(e);
                alert('There was an error');
                return;
            }
            this.closeRockCard();
            (this.$refs.inboxPanel as any)?.loadRocks();
        },
        async openMeetingItem(card: any) {
            if(!this.employees) {
                await axios.get(`${this.$store.state.apiUrl}/api/employees/limitedinfo`)
                    .then(resp => {
                        this.employees = resp.data.map((emp: any) => ({ ...emp, ID: Number(emp.ID) }));
                    })
                    .catch(e => {
                        console.log(e);
                    })
            }
            this.meetingItemCard = card;
        },
        closeMeetingItem() {
            this.meetingItemCard = null;
            this.loadItems(false);
        },
        // A meeting item card's checkbox is the item's own Completed (the same item on its meeting board)
        meetingItemCompleteChange(item: any) {
            axios.post(`${this.$store.state.apiUrl}/api/meetingitems/complete`, { MeetingID: item.MeetingItem.MeetingID, ID: item.MeetingItem.ID, Completed: item.Checked })
                .then(async () => {
                    await this.offerCompletedMove(item);
                    this.loadItems(false);
                })
                .catch(e => {
                    console.log(e);
                    item.Checked = !item.Checked;
                    alert(e?.response?.data || 'There was an error');
                })
        },
        // The card's checkbox (a rock card's too, which leaves the rock alone)
        async itemChange(item: any) {
            let saved = false;
            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems`, item)
                .then(() => {
                    saved = true;
                })
                .catch(e => {
                    console.log(e);
                })
            if(saved) {
                await this.offerCompletedMove(item);
            }
            this.loadItems(false);
        },
        // Checked off: does what the deck's setting says (Settings). By default, offers to move the card to the last column
        // (MoveColumnPrompt) unless it's there already, as on the meeting board. 'none' does nothing; 'move' moves it to the
        // chosen column, or offers the prompt when that column has since been removed.
        async offerCompletedMove(item: any) {
            if(!item.Checked || this.completeAction == 'none') {
                return;
            }
            if(this.completeAction == 'move' && this.columnNames.includes(this.completeColumn)) {
                if(item.Column != this.completeColumn) {
                    await this.moveItemToColumn(item.ID, this.completeColumn);
                }
                return;
            }
            const last = this.columnNames[this.columnNames.length - 1];
            if(this.columnNames.length >= 2 && item.Column != last) {
                this.completedMove = { itemID: item.ID, current: item.Column, column: last };
            }
        },
        settingsSaved(settings: any) {
            this.completeAction = settings.completeAction;
            this.completeColumn = settings.completeColumn;
            this.showSettings = false;
        },
        // The move prompt's Move: the same as dropping the card in that column (dragEnd), which puts it at the top
        async moveItemToColumn(itemID: number, column: string) {
            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/changecolumn`, { ID: itemID, Slug: this.formData.slug, Column: column })
                .catch(e => {
                    console.log(e);
                    alert('There was an error.')
                })
            this.loadItems(false);
        },
        getActivity() {
            if(this.showActivity) {
                this.showActivity = false;
                return;
            }
            axios.get(`${this.$store.state.apiUrl}/api/companyboards/activity/${this.$route.params.slug}`)
                .then(resp => {
                    if(!resp.data?.length) {
                        alert('There is no recent activity for this board');
                        return;
                    }
                    this.activity = [];
                    // Drops repeats of the same action on the same card that are next to each other
                    for(let i = 0; i < resp.data.length; i++) {
                        const a = resp.data[i];
                        const prev = resp.data[i - 1];
                        a.DateDisplay = new Date(a.Date).toLocaleString();
                        if(!prev || a.CardID != prev.CardID || a.Text != prev.Text || a.Username != prev.Username) {
                            this.activity.push(a);
                        }
                    }
                    this.activityCards = [];
                    for(const a of this.activity) {
                        if(!this.activityCards.find((ac: any) => ac.CardID == a.CardID)) {
                            this.activityCards.push({ CardID: a.CardID, CardName: a.CardName, DateDisplay: a.DateDisplay });
                        }
                    }
                    this.showActivityGroup = 'Details';
                    this.showActivity = true;
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error');
                })
        }
    }
})
</script>
